var _path, _path2, _circle, _circle2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitorsSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 8C102.891 8 121.968 15.9018 136.033 29.967C150.098 44.0322 158 63.1088 158 83C158 102.891 150.098 121.968 136.033 136.033C121.968 150.098 102.891 158 83 158",
    stroke: "#00B86B",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83 158C73.1509 158 63.3982 156.06 54.2987 152.291C45.1993 148.522 36.9314 142.997 29.967 136.033C23.0026 129.069 17.4781 120.801 13.709 111.701C9.93992 102.602 8 92.8491 8 83C8 73.1508 9.93994 63.3981 13.7091 54.2987C17.4782 45.1993 23.0026 36.9313 29.967 29.967C36.9314 23.0026 45.1994 17.4781 54.2988 13.709C63.3982 9.93991 73.1509 7.99999 83.0001 8",
    stroke: "#00B86B",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 25,
    r: 18,
    fill: "#00B86B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(1 0 0 -1 29.5 43)",
    fill: "#00B86B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7.5,
    rx: 1.5,
    transform: "matrix(1 0 0 -1 29.5 38.5)",
    fill: "#00B86B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 37C27.3726 37 22 31.6274 22 25C22 18.3726 27.3726 13 34 13C40.6274 13 46 18.3726 46 25C46 31.6274 40.6274 37 34 37ZM30.3321 23.2481L34 20.8028L37.6679 23.2481C38.3572 23.7076 39.2885 23.5213 39.7481 22.8321C40.2076 22.1428 40.0213 21.2115 39.3321 20.7519L34.8321 17.7519C34.3282 17.416 33.6718 17.416 33.1679 17.7519L28.6679 20.7519C27.9787 21.2115 27.7924 22.1428 28.2519 22.8321C28.7115 23.5213 29.6428 23.7076 30.3321 23.2481ZM30.3321 30.7481L34 28.3028L37.6679 30.7481C38.3572 31.2076 39.2885 31.0213 39.7481 30.3321C40.2076 29.6428 40.0213 28.7115 39.3321 28.2519L34.8321 25.2519C34.3282 24.916 33.6718 24.916 33.1679 25.2519L28.6679 28.2519C27.9787 28.7115 27.7924 29.6428 28.2519 30.3321C28.7115 31.0213 29.6428 31.2076 30.3321 30.7481Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorsSuccess);
export default __webpack_public_path__ + "static/media/monitors-success.e0f472565fdb0ccc9567281624031d21.svg";
export { ForwardRef as ReactComponent };